import React from "react";
import get from 'lodash/get'
import EntityForm from "modules/entity/forms";
import Form from "./Form";
import useTranslation from "../../../hooks/useTranslation";

const Create = ({ showCreateModal, loadItems, type, createCategoryModal, showCreateCategoryModal }) => {
  const { tr } = useTranslation();

  return (
    <EntityForm.Default
      method="post"
      url="/categories"
      onSuccess={(data, resetForm) => {
        if (get(createCategoryModal, "field") && get(createCategoryModal, "setFieldValue")) {
          const setFieldValue = get(createCategoryModal, "setFieldValue")
          const field = get(createCategoryModal, "field")
          setFieldValue(field, data)
          resetForm();
          showCreateCategoryModal({ open: false, field: "", setFieldValue: null })
          loadItems();
        }
        resetForm();
        showCreateModal(false);
        loadItems();
      }}
      fields={[
        {
          name: "type",
          value: type ? type : 1,
          required: true,
        },
        {
          name: "organization_id",
          value: 0,
        },
        {
          name: "name",
          required: true,
        },
        {
          name: "sort",
        },
        {
          name: "status",
          value: true,
          onSubmitValue: value => (value ? 1 : 0),
        },
      ]}
    >
      {({ isSubmitting, values, setFieldValue, errors, submitForm }) => {
        return (
          <div>
            <div className="modal-title">{tr("Добавить категорию продукта")}</div>
            <div className="modal-body">
              <Form {...{ isSubmitting, values, setFieldValue, submitForm }} />
            </div>
          </div>
        );
      }}
    </EntityForm.Default>
  );
};

export default Create;
